<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">客户管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <label style="margin-left: 16px;">性别筛选</label>
              <el-select v-model="sex" placeholder="Select" class="select-item">
                <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>消费次数</label>
              <el-input v-model="consumeNumMin" placeholder="次数最小值"></el-input>
              <span style="margin: 0 4px">-</span>
              <el-input v-model="consumeNumMax" placeholder="次数最大值"></el-input>
            </div>

            <div class="content-input-item">
              <DatePickerRange_1 title="消费时间段" labelWidth="6em" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>

            <div class="content-input-item">
              <label>小程序</label>
              <el-select v-model="weChatLoginState" placeholder="Select" class="select-item">
                <el-option v-for="item in weChatLoginStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <label style="margin-left: 16px;">消费类型</label>
              <el-select v-model="consumeType" placeholder="Select" class="select-item">
                <el-option v-for="item in consumeTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <DatePickerRange labelWidth="6em" title="上次消费时间" @date="getPreBookTime($event)" @check="getPreBookCheck($event)" :isChecked="isPreBookChecked"/>
            </div>


            <div class="content-input-item">
              <!--              <label>客户搜索</label>-->
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <el-space>
            <el-button type="primary" @click="editUserDialog(-1)" size="default">添加客户</el-button>
            <el-button type="danger" @click="getCustom()" size="default">门店散客</el-button>
<!--            <el-divider direction="vertical"></el-divider>-->
<!--            <el-badge is-dot :hidden="exemptionNum == 0">-->
<!--              <el-button @click="getBtnPage(1, true)" size="default">疫苗时间已到<span v-if="exemptionNum > 0">（{{exemptionNum}}）</span></el-button>-->
<!--            </el-badge>-->
<!--            <el-badge is-dot :hidden="outDriveNum == 0">-->
<!--              <el-button @click="getBtnPage(2, true)" size="default">外驱时间已到<span v-if="outDriveNum > 0">（{{outDriveNum}}）</span></el-button>-->
<!--            </el-badge>-->
<!--            <el-badge is-dot :hidden="inDriveNum == 0">-->
<!--              <el-button @click="getBtnPage(3, true)" size="default">内驱时间已到<span v-if="inDriveNum > 0">（{{inDriveNum}}）</span></el-button>-->
<!--            </el-badge>-->
          </el-space>
          <div style="display: flex;align-items: center;">
            <el-upload
                action="—"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="upLoadUser">
              <el-button v-loading="upUserLoading" type="warning" style="margin-left: 16px;">导入客户Excel</el-button>
            </el-upload>
<!--            <el-upload-->
<!--                action="—"-->
<!--                :auto-upload="false"-->
<!--                :show-file-list="false"-->
<!--                :on-change="upLoadPet">-->
<!--              <el-button v-loading="upPetLoading" type="success" style="margin-left: 16px;">导入宠物Excel</el-button>-->
<!--            </el-upload>-->
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
              @sort-change="sortChange"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1" width="110"/>
            <el-table-column property="" label="图片" v-if="checkColList.indexOf('图片') > -1" width="100">
              <template #default="scope">
                <div v-if="scope.row.userImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
                  <el-image class="item-img" fit="fill" :src="scope.row.userImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="客户信息" v-if="checkColList.indexOf('客户信息') > -1" width="160">
              <template #default="scope">
                <UserInfo :userId="scope.row.id" :row="scope.row" showList="name,sex,phone,shopName,uid" @confirm="getPage" />
                <p v-if="scope.row.type == 1">类型：门店散客</p>
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="猫咪信息" v-if="checkColList.indexOf('猫咪信息') > -1" class-name="cursor" width="200">
              <template #default="scope">
                <div style="margin: 8px 0;" v-for="(item, index) of scope.row.petList" :key="item.id">
                  <p>{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}} ({{item.name}}) <span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span> ({{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}) {{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</p>
                  <p v-if="item.exemptionDesc" style="color: red; font-size: 12px">*{{item.exemptionDesc}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="消费单" v-if="checkColList.indexOf('消费单') > -1" class-name="cursor" width="260">
              <template #default="scope">
                <ConsumeList :payList="scope.row.userConsumeList" />
              </template>
            </el-table-column>
            <el-table-column property="preBookTime" label="上次消费时间" v-if="checkColList.indexOf('上次消费时间') > -1" width="140" sortable='custom'>
              <template #default="scope">
                <p v-if="scope.row.userPerfect">{{scope.row.userPerfect.preBookTime}}</p>
              </template>
            </el-table-column>
            <el-table-column property="preBookNum" label="总消费次数" v-if="checkColList.indexOf('总消费次数') > -1" width="120" sortable='custom'>
            <template #default="scope">
              <p v-if="scope.row.userPerfect">{{scope.row.userPerfect.preBookNum}}</p>
            </template>
            </el-table-column>
<!--            <el-table-column property="" label="消费项目" v-if="checkColList.indexOf('消费单') > -1" class-name="cursor" width="240">-->
<!--              <template #default="scope">-->
<!--                <ProjectList :payList="scope.row.projectAllPageRespList" />-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column property="price" label="支付记录" v-if="checkColList.indexOf('支付记录') > -1" class-name="cursor" width="240">-->
<!--              <template #default="scope">-->
<!--                <PayList :payList="scope.row.paymentDetailPageRespList" />-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column property="orderNum" label="总消费金额" v-if="checkColList.indexOf('总消费金额') > -1">-->
<!--              <template #default="scope">-->
<!--                {{ (scope.row.userWallet.paySumOne  + scope.row.userWallet.paySumTwo + scope.row.userWallet.paySumThree + scope.row.userWallet.paySumFour) - (scope.row.userWallet.balanceOne  + scope.row.userWallet.balanceTwo + scope.row.userWallet.balanceThree + scope.row.userWallet.balanceFour) }}-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column property="" label="账户信息" v-if="checkColList.indexOf('账户信息') > -1" width="240">
              <template #default="scope">
                <p>总充值：{{ scope.row.userWallet.payAllSum }} <span style="color: #aaaaaa" v-if="scope.row.userWallet.payAllSum">（{{ scope.row.userWallet.paySum }} + {{ scope.row.userWallet.payGiveSum }}）</span></p>
                <p>总消费：{{ scope.row.userWallet.dedSum }}</p>
                <p>总余额：{{ scope.row.userWallet.balanceAllSum }}<span style="color: #aaaaaa" v-if="scope.row.userWallet.balanceAllSum">（{{ scope.row.userWallet.balanceSum }} + {{ scope.row.userWallet.balanceGiveSum }}）</span></p>
              </template>
            </el-table-column>
            <el-table-column property="medicalBenefit" label="医疗金余额" v-if="checkColList.indexOf('医疗金余额') > -1" class-name="cursor" width="140">
              <template #default="scope">
                <p style="color: #3a8ee6">{{ scope.row.userWallet.medicalBenefit}}</p>
                <p v-if="scope.row.userWallet.disableMedicalBenefit > 0">已过期：{{ scope.row.userWallet.disableMedicalBenefit}}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="110" fixed="right">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="editUserDialog(scope.$index,scope.row)" size="small" type="primary">修改资料</el-button>
                  <el-button @click="editConsume(scope.$index,scope.row)" size="small" type="warning">录入消费</el-button>
                  <el-button @click="sendInviteSms(scope.row)" size="small" type="success">发送短信</el-button>
                </el-space>
              </template>
            </el-table-column>
            <el-table-column property="" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor" width="260">
              <template #default="scope">
                <UserRemark :userRemarkList="scope.row.userRemarkList" />
              </template>
            </el-table-column>
            <el-table-column property="" label="客户日志" v-if="checkColList.indexOf('客户日志') > -1" class-name="cursor" width="260">
              <template #default="scope">
                  <UserLogList :userRemarkList="scope.row.userLogList" />
              </template>
            </el-table-column>
            <el-table-column property="" label="回访记录" v-if="checkColList.indexOf('回访记录') > -1" class-name="cursor" width="260">
              <template #default="scope">
                <VisitLog :userRemarkList="scope.row.visitList" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData,imgPostFormData } from "@/api/api";
import {
  getUserCustomerPageList,
  updateShopProjectState,
  getAllShopList,
  uploadUserExcel,
  uploadPetExcel,
  getUserInfo,
  getExemptionAllNum,
  sendInviteSms,
  updateAdminState
} from "@/api/url";
import UserDialog from "./components/UserDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemark from "@/components/Remark/UserRemark";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import VisitLog from "@/components/VisitLog/VisitLog";
import VisitLogDialog from "@/components/VisitLog/VisitLogDialog";
import UserLogList from "@/components/UserLogList/UserLogList";
import UserLogListDialog from "@/components/UserLogList/UserLogListDialog";
import UserInfo from "@/components/User/userInfo"
import PayList from "@/views/user/components/payment/PayList";
import PayListDialog from "@/views/user/components/payment/PayListDialog";
import ProjectList from "@/views/user/components/project/ProjectList";
import ProjectListDialog from "@/views/user/components/project/ProjectListDialog";
import ConsumeList from "@/views/user/components/ConsumeList";
import {decimal_NUM, Number_SubAll, add} from "@/assets/shared/util";
import ConsumeListDialog from "@/views/user/components/ConsumeListDialog";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
import PetListDialog from "@/views/user/components/PetListDialog";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import DatePickerRange_1 from "@/components/DatePickerRange_7_1";
import DatePickerRange from "@/components/DatePickerRange_7";
import medicalListDialog from "@/views/user/components/medical/medicalListDialog";

export default {
  name: "UserList",
  components: { BtnGroup, SearchComponents, UserRemark, UserInfo, ConsumeList, UserLogList, unLock, VisitLog, DatePickerRange_1, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
        {label: '未知', value: 0}
      ],
      sex: -1,


      consumeTypeArray: [
        {label: '不限', value: -1},
        {label: '美团券', value: 1},
        {label: '抖音券', value: 2},
      ],
      consumeType: -1,

      // neuteringStateArray: [
      //   {label: '不限', value: -1},
      //   {label: '已绝育', value: 1},
      //   {label: '未绝育', value: 2},
      //   {label: '未知', value: 0},
      // ],
      // neuteringState: -1,
      //
      // exemptionStateArray: [
      //   {label: '不限', value: -1},
      //   {label: '时间未到', value: 1},
      //   {label: '时间临近', value: 3},
      //   {label: '时间已到', value: 2},
      // ],
      // exemptionState: -1,
      //
      // outDriveStateArray: [
      //   {label: '不限', value: -1},
      //   {label: '时间未到', value: 1},
      //   {label: '时间临近', value: 3},
      //   {label: '时间已到', value: 2}
      // ],
      // outDriveState: -1,
      //
      // inDriveStateArray: [
      //   {label: '不限', value: -1},
      //   {label: '时间未到', value: 1},
      //   {label: '时间临近', value: 3},
      //   {label: '时间已到', value: 2}
      // ],
      // inDriveState: -1,

      weChatLoginStateArray: [
        {label: '不限', value: -1},
        {label: '未登录', value: 0},
        {label: '已登录', value: 1},
      ],
      weChatLoginState: -1,

      //刷新组
      colList: ['更新时间', '图片', '客户信息', '猫咪信息', '消费单', '上次消费时间', '总消费次数', '账户信息', '医疗金余额', '操作', '备注', '客户日志', '回访记录'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '宠物昵称', value : 3},
        {label : '客户备注', value : 4},
        {label : '主人ID', value : 5},
      ],
      searchType: 1,
      searchValue: '',
      limitState: true,

      upUserLoading: false,
      upPetLoading: false,

      exemptionNum: 0,
      outDriveNum: 0,
      inDriveNum: 0,
      btnType: 0,

      consumeNumMin: '',
      consumeNumMax: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //时间
      startPreBookTime: '',
      endPreBookTime: '',
      isPreBookChecked: true,

      sort: 1,
    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.limitState = true;
      this.isPreBookChecked = true;
      this.sex = -1;
      this.consumeType = -1;
      this.sort = 1;
      // this.exemptionState = -1;
      // this.outDriveState = -1;
      // this.inDriveState = -1;
      this.weChatLoginState = -1;
      this.shopId = 0;
      this.searchValue = '';
      this.consumeNumMin = '';
      this.consumeNumMax = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //排序
    sortChange(column) {
      if(column.prop == 'preBookTime') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'preBookNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      }
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getPreBookTime(val) {
      this.startPreBookTime = val[0];
      this.endPreBookTime = val[1];
      // console.log(val)
    },
    getPreBookCheck(val) {
      this.isPreBookChecked = val
    },

    upLoadUser(file) {
      // console.log(file)
      this.upUserLoading = true
      let param = new FormData();
      param.append('file', file.raw);
      imgPostFormData(uploadUserExcel, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.getPage(true)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.upUserLoading = false
      }).catch(()=>{
        this.upUserLoading = false
      })
    },

    upLoadPet(file) {
      // console.log(file)
      this.upPetLoading = true
      let param = new FormData();
      param.append('file', file.raw);
      imgPostFormData(uploadPetExcel, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.getPage(true)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.upPetLoading = false
      }).catch(()=>{
        this.upPetLoading = false
      })
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
      // if(this.btnType == 0) {
      //   this.getPage();
      // }else {
      //   this.getBtnPage(this.btnType)
      // }
    },

    getPage(reset) {
      // this.btnType = 0
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          this.sort = 1
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['sex'] = this.sex;
      param['consumeType'] = this.consumeType;
      // param['inDriveState'] = this.inDriveState;
      // param['outDriveState'] = this.outDriveState;
      // param['exemptionState'] = this.exemptionState;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['sort'] = this.sort;
      // param['neuteringState'] = this.neuteringState;
      param['weChatLoginState'] = this.weChatLoginState;
      param['startPreBookTime'] = this.startPreBookTime;
      param['endPreBookTime'] = this.endPreBookTime;
      param['consumeNumMin'] = this.consumeNumMin?this.consumeNumMin:0;
      param['consumeNumMax'] = this.consumeNumMax?this.consumeNumMax:0;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserCustomerPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.map(item => {
            item.userWallet.payAllSum = 0
            item.userWallet.paySum = 0
            item.userWallet.payGiveSum = 0
            item.userWallet.dedSum = 0
            item.userWallet.balanceAllSum = 0
            item.userWallet.balanceSum = 0
            item.userWallet.balanceGiveSum = 0
            item.userWallet.paySum = add([item.userWallet.paySumOne, item.userWallet.paySumTwo, item.userWallet.paySumThree, item.userWallet.paySumFour])
            item.userWallet.payGiveSum = add([item.userWallet.paySumOneGive, item.userWallet.paySumTwoGive, item.userWallet.paySumThreeGive, item.userWallet.paySumFourGive])
            item.userWallet.payAllSum = add([item.userWallet.paySum, item.userWallet.payGiveSum])
            item.userWallet.balanceSum = add([item.userWallet.balanceOne, item.userWallet.balanceTwo, item.userWallet.balanceThree, item.userWallet.balanceFour])
            item.userWallet.balanceGiveSum = add([item.userWallet.balanceOneGive, item.userWallet.balanceTwoGive, item.userWallet.balanceThreeGive, item.userWallet.balanceFourGive])
            item.userWallet.balanceAllSum = add([item.userWallet.balanceSum, item.userWallet.balanceGiveSum])
            item.userWallet.dedSum = Number_SubAll(item.userWallet.payAllSum, item.userWallet.balanceAllSum)
          })
          // this.pageDataList.sort(this.compare)
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getAllNum()
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    // getBtnPage(type, reset) {
    //   this.btnType = type
    //   if(isNaN(this.currentPage)) {
    //     this.$message({
    //       showClose: true,
    //       duration: 1000,
    //       message: '请提交正确的页码',
    //       type: 'warning'
    //     })
    //   } else {
    //     if(reset) {
    //       this.currentPage = 1;
    //     }
    //     this.searchLoading = true;
    //     this.listLoading = true;
    //
    //     let param = {};
    //     param['pageNum'] = this.currentPage;
    //     param['shopId'] = this.shopId;
    //     param['consumeNumMin'] = 0;
    //     param['consumeNumMax'] = 0;
    //     param['neuteringState'] = -1;
    //     param['weChatLoginState'] = -1;
    //     param['sex'] = -1;
    //     switch (type) {
    //       case 1:
    //         param['inDriveState'] = -1;
    //         param['outDriveState'] = -1;
    //         param['exemptionState'] = 2;
    //         break;
    //       case 2:
    //         param['inDriveState'] = -1;
    //         param['outDriveState'] = 2;
    //         param['exemptionState'] = -1;
    //         break;
    //       case 3:
    //         param['inDriveState'] = 2;
    //         param['outDriveState'] = -1;
    //         param['exemptionState'] = -1;
    //         break;
    //     }
    //     param['searchType'] = 1;
    //     param['searchValue'] = '';
    //
    //     this.sendPageReq(param);
    //   }
    // },


    compare(a, b) {
      const bandA = a.shopId;
      const bandB = b.shopId;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editUserDialog(idx, row) {
      let _title = '';
      let userForm = {}
      if (idx > -1) {
        _title = '修改资料'
        userForm = Object.assign({}, row);
        // console.log(userForm)
      }else {
        _title = '创建新客'
        // console.log(userForm)
      }
      Dialog.open({
        title: _title,
        component: UserDialog,
        data: {
          userForm: userForm,
          ids: idx,
          width: '700px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateShopProjectState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if(column.label == '备注') {
        Dialog.open({
          title: '用户备注',
          component: UserRemarkDialog,
          data: {
            id: row.id,
            width: '1100px'
          },
          close: () => {
            // row['userRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
            this.getPage()
          }
        })
      }

      //更新用户日志
      if(column.label == '客户日志') {
        Dialog.open({
          title: '客户日志',
          component: UserLogListDialog,
          data: {
            id: row.id,
            width: '1100px'
          },
          close: () => {
            // row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
            this.getPage()
          }
        })
      }

      //更新用户日志
      if(column.label == '回访记录') {
        Dialog.open({
          title: '回访记录',
          component: VisitLogDialog,
          data: {
            id: row.id,
            width: '1100px'
          },
          close: () => {
            // row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
            // this.getPage()
          }
        })
      }


      //医疗金余额
      if(column.label == '医疗金余额') {
        Dialog.open({
          title: '医疗金余额',
          component: medicalListDialog,
          data: {
            userId: row.id,
            width: '1100px'
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

      // //支付记录
      // if(column.label == '支付记录') {
      //   let userForm = Object.assign({}, row);
      //   Dialog.open({
      //     title: '支付记录',
      //     component: PayListDialog,
      //     data: {
      //       id: row.id,
      //       width: '1100px',
      //       userForm: userForm,
      //       shopIdArray: this.shopIdArray,
      //     },
      //     close: () => {
      //       if(JSON.parse(sessionStorage.getItem('recordState'))) {
      //         this.getPage()
      //       }
      //       sessionStorage.removeItem('recordState')
      //     }
      //   })
      // }
      //
      // //消费项目
      // if(column.label == '消费项目') {
      //   let userForm = Object.assign({}, row);
      //   Dialog.open({
      //     title: '消费项目',
      //     component: ProjectListDialog,
      //     data: {
      //       id: row.id,
      //       width: '1100px',
      //       userForm: userForm,
      //       shopIdArray: this.shopIdArray,
      //     },
      //     close: () => {
      //       if(JSON.parse(sessionStorage.getItem('recordState'))) {
      //         this.getPage()
      //       }
      //       sessionStorage.removeItem('recordState')
      //     }
      //   })
      // }

      //消费单
      if(column.label == '消费单') {
        let userForm = Object.assign({}, row);
        Dialog.open({
          title: '消费单',
          component: ConsumeListDialog,
          data: {
            id: row.id,
            width: '1200px',
            userForm: userForm,
            shopIdArray: this.shopIdArray,
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

      if(column.label == '猫咪信息') {
        let editable = true
        // let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
        // ownShopList.map(item => {
        //   if(item.id == row.shopId && item.isEdit == 1) {
        //     editable = true
        //   }
        // })
        Dialog.open({
          title: '猫咪信息',
          component: PetListDialog,
          data: {
            userForm: row,
            petList: row.petList,
            editable: editable,
            width: '1100px',
            userId: row.id,
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

    },

    editConsume(idx, row){
      let userForm = Object.assign({}, row);
      Dialog.open({
        title: '消费单',
        component: ConsumeListDialog,
        data: {
          id: row.id,
          width: '1100px',
          userForm: userForm,
          shopIdArray: this.shopIdArray,
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getPage()
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    getCustom() {
      let param = {}
      param['id'] = 0
      if(this.shopId == 0) {
        param['shopId'] = this.shopIdArray[1].id
      }else {
        param['shopId'] = this.shopId
      }
      getFormData(getUserInfo, param).then(data => {
        let consumeForm = {}
        let consumeId = 0
        Dialog.open({
          title: '',
          component: ConsumeDetailDialog,
          data: {
            userForm: data.data,
            consumeId: consumeId,
            idx: -1
          },
          confirm: (result) => {
            this.getPage();
            // sessionStorage.setItem('recordState', JSON.stringify(true))
          }
        })
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.userImgList,
          id: row.id,
          width: 908,
          from: 1
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getAllNum() {
      getFormData(getExemptionAllNum, {shopId: this.shopId}).then(data => {
        this.exemptionNum = data.data.exemptionNum
        this.outDriveNum = data.data.outDriveNum
        this.inDriveNum = data.data.inDriveNum
      })
    },

    sendInviteSms(row) {
      this.$confirm('确定给客户【'+ row.name +'】发送评价邀请短信吗？', {
        type: 'warning'
      }).then(
          () => {
            let param = {}
            param['id'] = row.id
            postFormData(sendInviteSms, param).then(data => {
              let {msg, code } = data;
              if(code == 200) {
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                })
              }else{
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                })
              }
            })
          }
      ).catch(() => {})
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
}


</style>
